import { cloneElement } from "react";
import type { ReactElement } from "react";
import { useHideOnboardingConfirmationModal } from "@/react/components/Modals/HideOnboardingConfirmationModal";

interface LeftProps {
  children: ReactElement;
}

export const Left = ({ children }: LeftProps) => {
  const hideOnboardingConfirmationModal = useHideOnboardingConfirmationModal();
  return (
    <div className="sidebar sidebar--left">
      <div className="sidebar__content" data-draggable="false">
        {cloneElement(children, {
          onClickRemoveOnboarding: hideOnboardingConfirmationModal.show,
        })}
      </div>
    </div>
  );
};
